module.exports = __webpack_public_path__ + "static/ryan-c1aa3152193015cd5970e4eb82488fa3.png";